import searchGames from './searchGames';

const placeholder = () => {};

export { searchGames, placeholder };
